import cx from 'classnames';
import { CDN_CLRSAVE_URL } from '../../constants';

import styles from '../../styles/plan/checkedTips.scss';

const tips = [
  'Portfolio of Large, Mid Cap with a small portion in Debt to ensure Balanced Growth',
  'SBI and Aditya Birla Frontline Equity are high performing funds with higher portion in large companies',
  'SBI Bluechip has also given best possible returns while keeping risk low, and also has been consistent performer over 10 years',
  'DSP Mid Cap has higher portion in mid size companies with over 25 % - 5 Year Return, it has also been a top performing fund in this category',
];

const CheckedTips = (props: any) => (
  <ul>
    {(props.tips || tips).map((tip: string) => (
      <li
        key={tip}
        className={cx(
          styles.tip,
          {
            [styles.congested]: props.congested,
            [styles['mandate-tips']]: props.mandate,
          },
          props.listItemClassName
        )}
      >
        <img
          className={cx(styles['tip-image'])}
          src={`${CDN_CLRSAVE_URL}/clearsave/images/block_tick.svg`}
          alt="check"
        />
        <span
          className={cx(
            'inline-block text--md',
            styles['tip-text'],
            props.tickTextClassname
          )}
          style={{ width: `calc(100% - ${props.tickWidth || '18px'})` }}
          dangerouslySetInnerHTML={{
            __html: tip,
          }}
        />
      </li>
    ))}

    {props.mandate ? (
      <li
        className={cx(styles.tip, {
          [styles.congested]: props.congested,
          [styles['mandate-tips']]: props.mandate,
        })}
      >
        <img
          className={styles['tip-image']}
          src={`${CDN_CLRSAVE_URL}/clearsave/images/block_tick.svg`}
          alt="check"
        />
        <span
          className={cx('inline-block text--md', styles['tip-text'])}
          style={{ width: `calc(100% - ${props.tickWidth || '18px'})` }}
        >
          {props.children}
        </span>
      </li>
    ) : null}
  </ul>
);

export default CheckedTips;



// WEBPACK FOOTER //
// ./components/common/checkedTips.tsx